// Countdown Timer Logic
document.addEventListener('DOMContentLoaded', function() {
  // Function to calculate the next 7-day cycle
  function getNext7DayCycle() {
    var now = new Date().getTime();
    return new Date(now + 7 * 24 * 60 * 60 * 1000).getTime(); // Adds 7 days in milliseconds
  }

  // Set the initial countdown date to 7 days from now
  var countdownDate = getNext7DayCycle();

  var countdownFunction = setInterval(function() {
    var now = new Date().getTime();
    var distance = countdownDate - now;

    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in respective elements
    document.getElementById("days").innerHTML = days;
    document.getElementById("hours").innerHTML = hours;
    document.getElementById("minutes").innerHTML = minutes;
    document.getElementById("seconds").innerHTML = seconds;

    // If the countdown is over, reset to the next 7-day cycle
    if (distance < 0) {
      countdownDate = getNext7DayCycle(); // Reset countdown to the next 7-day cycle
    }
  }, 1000);
});


// <!-- Countdown Timer Liquid Code -->
// <div class="countdown-timer">
//     <h2 class="countdown-title">LAMINATE SALE</h2>
//     <div class="countdown-timer__container">
//         <div class="countdown">
//             <span id="days" class="countdown-number">00</span>
//             <span class="countdown-label">DAYS</span>
//         </div>
//         <div class="countdown">
//             <span id="hours" class="countdown-number">00</span>
//             <span class="countdown-label">HOURS</span>
//         </div>
//         <div class="countdown">
//             <span id="minutes" class="countdown-number">00</span>
//             <span class="countdown-label">MINUTES</span>
//         </div>
//         <div class="countdown">
//             <span id="seconds" class="countdown-number">00</span>
//             <span class="countdown-label">SECONDS</span>
//         </div>
//     </div>
//     <a href="/collections/laminate-flooring" class="view-floors-btn">VIEW FLOORS</a>
// </div>

// <style>
//     /* Basic Styling for Countdown */
//       .countdown-timer {
//     box-sizing: border-box;
//         text-align: center;
//         padding: 20px;
//         background-color: #4b9aa7;
//         color: white;
//         display: flex;
//         justify-content: center;
//         align-items: center;
//         width: 100%;
//       }
//     .countdown-title{
//     color: white;
//        padding: 1rem;
//     margin: -1rem;
//     font-size:6rem;
//         font-weight: bold;
//     }
//       .countdown-timer__container {
//     margin: 1rem;
//         display: flex;
//         justify-content: center;
// padding-top:2rem;
//         align-items: center;
//         gap: 20px;
//       }
//       .countdown {
//         display: flex;
//         flex-direction: column;
//         align-items: center;

     
//       }
//       .countdown-number {
    
//        font-size: 2.2em;
//     font-weight: bold;
//     height: 5.9rem;
//       }
    
//       .view-floors-btn {
//         padding: 10px 20px;
//         background-color: black;
//         color: white;
//         text-decoration: none;
// margin-bottom:2rem;
//         margin-top: 20px;
//     padding: 1.5rem;
//     border-radius: 15px;
//       }
//     .countdown-number{background-color: white;
//         color: black;
//         border-radius: 15px;
//     box-sizing: border-box;
//       padding: 0rem 1.5rem;  }
    
//     @media only screen and (max-width: 900px){
// .countdown-timer__container{
// line-height: 5rem;
// }
//     .countdown-timer{
//     display:block;
    
//     }
//     .countdown-title{
//     font-size:4rem;
// line-height:1.5rem;
//     }
//      .countdown-number {
    
//         font-size: 2em;
//         font-weight: bold;
// height: 5rem;
//       }
//      .view-floors-btn {
//         padding:1rem;
//     border-radius: 15px;
//       }
// </style>